import { css } from '@/styled-system/css';
import { Icon } from '@zillow/constellation-10';
import { IconCheckmarkFilled, IconCloseFilled, IconInfoFilled } from '@zillow/constellation-icons';

export const permissionDescriptionIconStyles = css({
  marginRight: '400',
});

export const StyledIconCheckmark = () => (
  <Icon render={<IconCheckmarkFilled />} color="brand" className={permissionDescriptionIconStyles} />
);

export const StyledIconClose = () => (
  <Icon render={<IconCloseFilled />} color="red500" className={permissionDescriptionIconStyles} />
);

export const StyledIconInfo = () => <Icon render={<IconInfoFilled />} css={{ marginLeft: '4px' }} />;

export const styledPreviewPropertyTableContainerStyles = css({
  maxHeight: '40vh',
  overflowY: 'scroll',
});

export const styledAddUserPageStyles = css({
  '& .flex': {
    display: 'flex',
  },
  '&-container': {
    '@media screen and (max-width: 767px)': {
      padding: 0,
      maxWidth: '100%',
    },
  },
  '& .Questions-title': {
    flex: 1,
  },
  '& .Questions-button': {
    marginRight: '16px',
  },
  '& .Questions-footer': {
    padding: '32px 0',
    display: 'flex',
    justifyContent: 'space-between',
    '& a': {
      display: 'inline-flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  '& .Questions-padding-top': {
    paddingTop: '16px',
  },
  '&-bold': {
    fontWeight: 'bold',
  },
  '& .Badge': {
    margin: '0 16px',
    padding: '0 8px',
  },
  '&-preview-values': {
    marginTop: '16px',
    '& .Text': {
      marginBottom: '16px',
    },
    '& a': {
      marginLeft: '8px',
    },
  },
  '&-list-box': {
    marginTop: '16px',
    border: '1px solid',
    borderColor: 'border.neutral.secondary',
    '&-list-box-header': {
      padding: '32px 16px',
      borderBottom: '1px solid',
      borderBottomColor: 'border.neutral.secondary',
      '& .Text-h4': {
        display: 'inline-block',
        marginRight: '16px',
      },
    },
    '&-list-box-body': {
      padding: '8px 16px',
    },
    '&-list-box-item': {
      padding: '32px 0',
      '&:not(:last-child)': {
        borderBottom: '1px solid',
        borderBottomColor: 'border.neutral.secondary',
      },
    },
    '&-list-box-row': {
      display: 'flex',
      padding: '16px 0',
    },
    '&-list-box-col': {
      flexGrow: 1,
      flexBasis: 0,
    },
    '&-list-header': {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  '& .HR': {
    margin: '64px 0 0 0',
  },
  '&-questions': {
    '& .Checkbox': {
      marginBottom: '32px',
    },
    '& .Checkbox-box': {
      marginRight: '16px',
    },
    '& .Checkbox-description': {
      fontSize: '14px',
    },
  },
  '& .PropertyPicker-container': {
    border: '1px solid',
    borderColor: 'border.neutral.secondary',
    marginTop: '16px',
  },
  '& .PropertyPicker-top-banner': {
    padding: '32px',
    borderBottom: '5px solid',
    borderBottomColor: 'border.accent.brand.hero',
    '& .Col': {
      padding: 0,
    },
  },
});
